/// <amd-module name="Repos/Views/PullRequest/Components/ActivityFeed/ActivityFeedIntersectionRow" />
import * as React from "react";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { IIntersectionContext, IntersectionContext } from "VSSUI/Intersection";
import { getActivityFeedShimService, IActivityFeedShimService } from "../../ActivityFeedShimService";

interface IActivityFeedLoadingRowProps {
    rowIndex: number;
    rowKey: string;
}

export class ActivityFeedIntersectionRow extends VssComponent<IActivityFeedLoadingRowProps> {
    private activityFeedShimService: IActivityFeedShimService;
    private intersectionContext: IIntersectionContext;
    private loadingElement: HTMLDivElement | null;

    public constructor(props: IActivityFeedLoadingRowProps, context: IVssComponentContext) {
        super(props, context);

        this.activityFeedShimService = getActivityFeedShimService(context.pageContext);
    }

    public componentDidMount = () => {
        if (this.intersectionContext) {
            this.intersectionContext.register(this.onIntersect);
        }
    };

    public componentWillUnmount = () => {
        if (this.intersectionContext) {
            this.intersectionContext.unregister(this.onIntersect);
        }
    };

    public render = (): JSX.Element => {
        return (
            <IntersectionContext.Consumer>
                {intersectionContext => {
                    this.intersectionContext = intersectionContext;
                    return (
                        <div className="flex-grow scroll-hidden" ref={element => this.observeElement(element)}>
                            {this.props.children}
                        </div>
                    );
                }}
            </IntersectionContext.Consumer>
        );
    };

    private observeElement = (element: HTMLDivElement | null) => {
        if (this.activityFeedShimService.getShimState(this.props.rowKey, this.props.rowIndex)) {
            if (this.intersectionContext) {
                if (this.loadingElement) {
                    this.intersectionContext.unobserve(this.loadingElement);
                }
                if (element) {
                    this.loadingElement = element;
                    this.intersectionContext.observe(element);
                }
            }
        }
    };

    private onIntersect = (entries: IntersectionObserverEntry[]) => {
        if (this.activityFeedShimService.getShimState(this.props.rowKey, this.props.rowIndex)) {
            for (const entry of entries) {
                if (entry.target === this.loadingElement && entry.isIntersecting) {
                    this.loadingElement && this.intersectionContext.unobserve(this.loadingElement);
                    this.loadingElement = null;
                    this.activityFeedShimService.disableShim(this.props.rowKey, this.props.rowIndex);
                }
            }
        }
    };
}
